import {
    IS_AUTHENTICATED,
    AUTHENTICATE,
    INVALIDATE,
    SET_USER_INFO,
    CHANGE_ENVIRONMENT,
    SET_OR_UPDATE_NONCES,
    MAINTENANCE_SETTINGS
} from './mutation-types'

export default {
    [SET_OR_UPDATE_NONCES](state, payload) {
        if(payload.cmd === 'update')
            payload.nonce = state.nonces.splice(0, 1)
        else if(payload.cmd === 'set')
            state.nonces = payload.nonces
    },
    
    [CHANGE_ENVIRONMENT](state, payload) {
        if(typeof payload.env == 'string') {
            payload.env = payload.env.toUpperCase()
            
            if(typeof process.env['VUE_APP_API_BASE_'+payload.env] != 'undefined') {
                state.forcedEnv = payload.env
                state.baseUrl = process.env['VUE_APP_API_BASE_'+payload.env]
                state.authUrl = process.env['VUE_APP_AUTH_BASE_'+payload.env]
            }
        }
    },
    
    [IS_AUTHENTICATED](state) {
        if(state.baseUrl === '') {
            let host = window.location.hostname.split('.')[0]
            host = /-(dev|stg|qas|prd)$/i.exec(host)
            
            host = !host ?process.env.VUE_APP_DEFAULT_ENVIRONMENT :host[1].toUpperCase()
            state.defaultEnv = state.forcedEnv = host
            
            let forcedEnv = localStorage.getItem('forcedEnv')
            
            if(forcedEnv && typeof process.env['VUE_APP_API_BASE_'+forcedEnv] != 'undefined') {
                state.forcedEnv = forcedEnv
                host = forcedEnv
            }
            
            state.baseUrl = process.env['VUE_APP_API_BASE_'+host]
            state.authUrl = process.env['VUE_APP_AUTH_BASE_'+host]
        }
        
        if(state.token === '' && localStorage.getItem('token')) {
            state.token = localStorage.getItem('token')
            state.tokenType = localStorage.getItem('tokenType')
            state.clientKey = localStorage.getItem('clientKey')
            
            if(localStorage.getItem('userInfo'))
                state.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        }
    },
    
    [AUTHENTICATE](state, payload) {
        state.token = payload.token
        localStorage.setItem('token', state.token)
        
        state.tokenType = 'Basic'
        localStorage.setItem('tokenType', state.tokenType)
        
        state.clientKey = payload.clientKey
        localStorage.setItem('clientKey', state.clientKey)
    },
    
    [INVALIDATE](state) {
        localStorage.removeItem('forcedEnv')
        localStorage.removeItem('token')
        localStorage.removeItem('tokenType')
        localStorage.removeItem('clientKey')
        localStorage.removeItem('userInfo')
    },
    
    [SET_USER_INFO](state, payload) {
        payload.timeDiff = new Date().getTimezoneOffset() * -60
        state.userInfo = payload
        localStorage.setItem('userInfo', JSON.stringify(payload))
    },
    
    [MAINTENANCE_SETTINGS](state, payload) {
        state.maintenance = payload
    }
}
